import {
  ClawbackOp,
  MuxedAccount,
  Operation,
  OperationBody,
} from "../../xdr/index.js";
import { decodeAddressToMuxedAccount } from "../util/decode_encode_muxed_account.js";
import { ClawbackOpts, OperationAttributes } from "./types.js";
import {
  constructAmountRequirementsError,
  isValidAmount,
  setSourceAccount,
  toXdrAmount,
} from "../util/operations.js";

/**
 * Creates a clawback operation.
 *
 *
 * @param opts - Options object
 *   - `asset`: The asset being clawed back.
 *   - `amount`: The amount of the asset to claw back.
 *   - `from`: The public key of the (optionally-muxed)
 *     account to claw back from.
 *   - `source`: The source account for the operation.
 *     Defaults to the transaction's source account.
 *
 * @see https://github.com/stellar/stellar-protocol/blob/master/core/cap-0035.md#clawback-operation
 */
export function clawback(opts: ClawbackOpts): Operation {
  if (!isValidAmount(opts.amount)) {
    throw new TypeError(constructAmountRequirementsError("amount"));
  }

  let from: MuxedAccount;
  try {
    from = decodeAddressToMuxedAccount(opts.from);
  } catch {
    throw new Error("from address is invalid");
  }

  const clawbackOp = new ClawbackOp({
    amount: toXdrAmount(opts.amount),
    asset: opts.asset.toXdrObject(),
    from,
  });

  const opAttributes: OperationAttributes = {
    sourceAccount: null,
    body: OperationBody.clawback(clawbackOp),
  };
  setSourceAccount(opAttributes, opts);

  return new Operation(opAttributes);
}
